import { getType, prevent } from '@/utils/base';

//事件绑定
export function addEvent(type, obj, fn){
  if(obj.addEventListener){
    // obj.addEventListener(type, fn, false);
    obj.addEventListener(type, fn, {
      passive: false,
    });
  } else if (obj.attachEvent){
    obj.attachEvent('on'+ type, fn);
  }
}
export function removeEvent(type, obj, fn){
  if (obj.removeEventListener){
    obj.removeEventListener(type, fn, false);
  } else if (obj.detachEvent){
    obj.detachEvent('on'+ type, fn);
  }
}

//class 添加、删除、判断有无
export function hasClass(element, className){
  // return !!element.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
  return new RegExp('(\\s|^)' + className + '(\\s|$)').test(element.className);
}
export function addClass(element, cName){
  if (!hasClass(element, cName)) {
    element.className += ` ${cName}`;
  }
}
export function removeClass(element, cName){
  if ( hasClass(element, cName) ){
    element.className = element.className.replace(new RegExp( '(\\s|^)' + cName + '(\\s|$)' ), ' '); }
}

//获取元素样式
export function getStyle(element, pseudoElt=null) {
  if (window.getComputedStyle) {
    return window.getComputedStyle(element, pseudoElt);
  } else if(element.currentStyle){ //IE专用
    return element.currentStyle;
  }
  return null;
}

// 获取边框宽度
export function getBorder(ele){
  let eleStyle = getStyle(ele);
  let borderLeft = Number.parseInt(eleStyle['border-left-width'].slice(0, -2));
  let borderTop = Number.parseInt(eleStyle['border-top-width'].slice(0, -2));

  return { borderLeft, borderTop };
}
// 获取任意一个元素距离页面上的位置
export function getPos(ele, targetParent){
  targetParent = targetParent ? targetParent : null;

  let parent = ele.offsetParent;
  let left = ele.offsetLeft + getBorder(parent).borderLeft;
  let top  = ele.offsetTop + getBorder(parent).borderTop;
  // console.log(parent, left, top);

  while (parent !== targetParent){
    left += parent.offsetLeft;
    top += parent.offsetTop;
    parent = parent.offsetParent;
    
    if (parent !== null && parent !== document.body){
      left += getBorder(parent).borderLeft;
      top  += getBorder(parent).borderTop;
    }
    // console.log(parent, left, top);
  }

  return { left, top };
}

//获取浏览器滚动条宽度
export function getScrollbarWidth() {
  var odiv = document.createElement('div');//创建一个div
  var styles = {
    width: '100px',
    height: '100px',
    overflowY: 'scroll'//让他有滚动条
  };
  var i, scrollbarWidth;

  for (i in styles) odiv.style[i] = styles[i];
  document.body.appendChild(odiv);//把div添加到body中
  scrollbarWidth = odiv.offsetWidth - odiv.clientWidth;//相减
  odiv.remove();//移除创建的div
  return scrollbarWidth;//返回滚动条宽度
}

//获取视口、页面大小
export function getViewSize(ele){
  if (ele){
    return {
      width: ele.clientWidth,
      height: ele.clientHeight,
    };
  } else {
    const db = document.body;
    const de = document.documentElement;
    // 标准模式 CSS1Compat； 怪异模式 BackCompat；
    const dc = document.compatMode === "CSS1Compat" ? de : db;

    return {
      width: dc.clientWidth,
      height: dc.clientHeight,
    };
  }
}
export function getPageSize(ele){
  // document.compatMode用来判断当前浏览器采用的渲染方式。
  // BackCompat：标准兼容模式关闭。
  // CSS1Compat：标准兼容模式开启。
  // 当document.compatMode等于BackCompat时，浏览器客户区宽度是document.body.clientWidth；
  // 当document.compatMode等于CSS1Compat时，浏览器客户区宽度是document.documentElement.clientWidth。

  if (ele){
    return {
      width: ele.scrollWidth,
      height: ele.scrollHeight,
    };
  } else {
    const db = document.body;
    const de = document.documentElement;
    // 标准模式 CSS1Compat； 怪异模式 BackCompat；
    const dc = document.compatMode === "CSS1Compat" ? de : db;

    return {
      width: dc.scrollWidth,
      height: dc.scrollHeight,
    };
  }
}

// 获取dom 尺寸信息
// 注意：IE、Firefox3+、Opera9.5、Chrome、Safari支持，在IE中，默认坐标从(2,2)开始计算，导致最终距离比其他浏览器多出两个像素，我们需要做个兼容。
// document.documentElement.clientTop;  // 非IE为0，IE为2
// document.documentElement.clientLeft; // 非IE为0，IE为2
export function getBoundingRect (element) {
  element = element ? element : document.documentElement;
  let rect = element.getBoundingClientRect();
  let top = document.documentElement.clientTop;
  let left= document.documentElement.clientLeft;

  return {
    top    :   Math.floor(rect.top - top, 10),  //元素上边距离页面上边的距离
    bottom :   Math.floor(rect.bottom - top, 10),  //元素下边距离页面上边的距离
    left   :   Math.floor(rect.left - left, 10),  //元素左边距离页面左边的距离
    right  :   Math.floor(rect.right - left, 10), //元素右边距离页面左边的距离
    width: Math.round(rect.width, 10),
    height: Math.round(rect.height, 10),
  };
}

//获取、设置滚动条位置，缓动(设置已废弃，新的： srcollTo)
export function scrollTop(value){
  let de = document.documentElement;
  let db = document.body;

  function aa(value){
    if (document.compatMode === "CSS1Compat"){
      de.scrollTop = value;
      db.scrollTop = value; //有些chrome 版本很怪异 ，DTD，但是又不支持document.documentElement.scrollTop
    } else{
      db.scrollTop = value;
    }
  }

  if (value === undefined){
    // return de.scrollTop || window.pageYOffset || db.scrollTop;
    if (window.pageYOffset !== undefined) {
      return window.pageYOffset;
    } else if (document.compatMode === "CSS1Compat") {//有DTD约束
      return de.scrollTop === 0 ? db.scrollTop : de.scrollLeft;
    } else{//没有DTD约束   “BackCompat”
      return db.scrollTop;
    }
  } else if(getType(value) === 'number'){

    for (let i=1; i<=100; i++){
      let top = value* (i/100);
      aa(top);
      setTimeout(()=> {
        aa(top);
      }, 3*i);
    }
  }
}
//获取、设置滚动条位置，无缓动
export function scrollTop2(value){
  let de = document.documentElement;
  let db = document.body;

  if (value === undefined){
    // return de.scrollTop || window.pageYOffset || db.scrollTop;
    if (window.pageYOffset !== undefined) {
      return window.pageYOffset;
    } else if (document.compatMode === "CSS1Compat") {//有DTD约束
      return de.scrollTop === 0 ? db.scrollTop : de.scrollLeft;
    } else{//没有DTD约束   “BackCompat”
      return db.scrollTop;
    }
  } else if(getType(value) === 'number'){
    if (document.compatMode === "CSS1Compat"){
      de.scrollTop = value;
      db.scrollTop = value; //有些chrome 版本很怪异 ，DTD，但是又不支持document.documentElement.scrollTop
    } else{
      db.scrollTop = value;
    }
  }
}

//(设置已废弃)
export function scrollLeft(value){
  let de = document.documentElement;
  let db = document.body;

  if (value === undefined){
    // return de.scrollLeft || window.pageXOffset || db.scrollLeft;
    if (window.pageXOffset !== undefined){
      return window.pageXOffset;
    } else if(document.compatMode === 'CSS1Compat'){
      return de.scrollLeft === 0 ? db.scrollLeft : de.scrollLeft;
    } else{
      return db.scrollLeft;
    }
  } else if(getType(value) === 'number'){
    if (document.compatMode === 'CSS1Compat'){
      de.scrollLeft = value;
      db.scrollLeft = value;
    } else {
      db.scrollLeft = value;
    }
  }
}

export function getScrollTop(ele){
  if (ele){
    return Math.round(ele.scrollTop);
  } else {
    return scrollTop();
  }
}

/**
 * [scrollTo2 页面、element滚动函数]
 * @ele  [element]
 * @direction  [方向，默认：'column'上下； 'row'左右]
 * @position  [滚动位置]
 * @time  [滚动缓冲时间]
*/
export function scrollTo(opt={}){
  let initPosition = 0;  //初始滚动位置
  let position = opt.position;  //目标滚动位置
  let isColumn =  opt.direction !== 'row';  //滚动方向
  let de = document.documentElement,  db = document.body;

  if (opt.ele){
    initPosition  = isColumn ? opt.ele.scrollTop : opt.ele.scrollLeft;
  } else {
    if (isColumn){
      initPosition = de.scrollTop || db.scrollTop;
    } else {
      initPosition = de.scrollLeft || db.scrollLeft;
    }
  }

  let stepTime = 10;  //单次滚动时长，默认10ms秒滚动一次
  let totalJump = (opt.time / stepTime) || 1; //滚动次数
  let diffPosition = Math.abs(position - initPosition); //滚动偏移量
  let step = diffPosition / totalJump;  //滚动步长
  // console.log(step, totalJump);

  if (position > initPosition){
    smoothDown();
  } else{
    smoothUp();
  }

  function smoothDown () {
    if (initPosition < position){
      initPosition += step;
      scrollToPublic(initPosition);

      setTimeout(smoothDown, stepTime);
    } else {
      scrollToPublic(position);
    }
  }

  function smoothUp () {
    if (initPosition > position){
      initPosition -= step;
      scrollToPublic(initPosition);

      setTimeout(smoothUp, stepTime);
    } else {
      scrollToPublic(position);
    }
  }

  function scrollToPublic(targetPosition){
    if (opt.ele){
      if (isColumn){
        opt.ele.scrollTop = targetPosition;
      } else {
        opt.ele.scrollLeft = targetPosition;
      }

    } else {
      if (isColumn){
        db.scrollTop = targetPosition;
        de.scrollTop = targetPosition;
      } else{
        db.scrollLeft = targetPosition;
        de.scrollLeft = targetPosition;
      }
    }
  }
}




// 检查是否滚动到了底部(距底部多少)
export function isScrollBottom(height = 50, ele){
  const scrollTop = getScrollTop(ele);
  const scrollHeight = getPageSize(ele).height;
  const clientHeight = getViewSize(ele).height;
  const position = scrollHeight - clientHeight - height;
  return scrollTop >= position; 
}

// 是否出现了滚动条
export function isScroll(el) {
  // test targets
  var elems = el ? [el] : [document.documentElement, document.body];
  var scrollX = false, scrollY = false;
  for (var i = 0; i < elems.length; i++) {
    var o = elems[i];
    // test horizontal
    var sl = o.scrollLeft;
    o.scrollLeft += (sl > 0) ? -1 : 1;
    o.scrollLeft !== sl && (scrollX = scrollX || true);
    o.scrollLeft = sl;
    // test vertical
    var st = o.scrollTop;
    o.scrollTop += (st > 0) ? -1 : 1;
    o.scrollTop !== st && (scrollY = scrollY || true);
    o.scrollTop = st;
  }
  // ret
  return {
    scrollX: scrollX,
    scrollY: scrollY
  };
}

// 切换 禁止触摸操作
// handleStopWxTouchMove = (flag) => {
//   body 需在touchstart里才能触发touchmove 
//   if (flag){
//     addEvent('touchstart', document.body, this.touchstartCallback);
//   } else {
//     removeEvent('touchstart', document.body, stopWxTouchMove);
//     removeEvent('touchmove', document.body, stopWxTouchMove);
//   }
// }
// touchstartCallback = () => {
//   addEvent('touchmove', document.body, stopWxTouchMove);
// }

// 微信浏览器禁止页面下拉（手机touchmove默认事件行为）
export function stopWxTouchMove(evt){
  // console.log('touchmove =>', evt._isScroller);
  if(!evt._isScroller) {
    prevent();
  }
}
export function openWxTouchMove(el){
  el.addEventListener('touchstart', function() {
    let top = el.scrollTop;
    let totalScroll = el.scrollHeight;
    let currentScroll = top + el.offsetHeight;
    
    if(top === 0) {
      el.scrollTop = 1;
    } else if(currentScroll === totalScroll) {
      el.scrollTop = top - 1;
    }
  });
  el.addEventListener('touchmove', function(evt) {
    if(el.offsetHeight < el.scrollHeight){
      evt._isScroller = true;
    }
  });
}


// rem转换px
export function getRealFromRem(num){
  let winW = getBoundingRect().width;
  let rem = winW * 100 / 375;

  let number = (num.slice(0, -3)) * rem;
  return number;
}



// 获取设备像素比 DPR
export function getDPR() {
  if (window.devicePixelRatio && window.devicePixelRatio > 1) {
    return window.devicePixelRatio;
  }
  return 1;
}

// 让当前的元素滚动到浏览器窗口的可视区域内。
// alignToTop - 如果为true，元素的顶端将和其所在滚动区的可视区域的顶端对齐。
// 相应的 scrollIntoViewOptions: {block: "start", inline: "nearest"}。这是这个参数的默认值。
// 如果为false，元素的底端将和其所在滚动区的可视区域的底端对齐。相应的scrollIntoViewOptions: {block: "end", inline: "nearest"}。

// scrollIntoViewOptions.behavior  定义动画过渡效果， "auto"或 "smooth" 之一。默认为 "auto"。
// scrollIntoViewOptions.block  定义垂直方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "start"。
// scrollIntoViewOptions.inline  定义水平方向的对齐， "start", "center", "end", 或 "nearest"之一。默认为 "nearest"。
export function eleScrollIntoView(ele, alignToTop=true, opt){
  if (!ele) return;
  if (alignToTop){
    ele.scrollIntoView(alignToTop);
  } else {
    ele.scrollIntoView(opt);
  }
}

// 把一个节点插入到容器的指定节点之后
export function insertAfter(newNode, oldNode){
  let parent = oldNode.parentNode;

  if ( parent.lastChild === oldNode){
    parent.appendChild(newNode);
  } else {
    parent.insertBefore(newNode, oldNode.nextSibling);
  }
}

// 获取页面滚动高度
export function getBodyScrollHeight(){
  const scrollheight = document.body.scrollTop === 0 ? document.documentElement.scrollTop
    : document.body.scrollTop;
  return scrollheight;
}

// 获取真实px
export function getPxFromRem(num){
  var docEle = document.documentElement;
  var deviceWidth = docEle.clientWidth || window.innerWidth;
  if (deviceWidth >= 440) deviceWidth = 440;
  const fontSize = deviceWidth / 3.75;
  return Math.ceil(num * fontSize);
} 

// 获取元素的样式值
export function getCss(ele, attr) {
  var res = null;
  try {
    res = window.getComputedStyle(ele)[attr];
  } catch (e) {
    res = ele.currentStyle[attr];
  }
  //=> 判断 res 是不是数字加单位的类型
  //=> 使用 parseFloat
  isNaN(parseFloat(res)) ? null : res = parseFloat(res);
  
  //=> 使用正则
  var reg = /[+-]?(\d|[1-9]\d+)(\.\d+)?(px|rem|em|pt)?/;
  if(reg.test(res)) {
    res = parseFloat(res);
  }
  return res;
}